var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubtract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 42,
    viewBox: "0 0 52 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7C0 3.13401 3.13401 0 7 0H45C48.866 0 52 3.13401 52 7V35C52 38.866 48.866 42 45 42H7C3.13401 42 0 38.866 0 35V7ZM7.28402 36.5172H43.9899C46.437 35.7171 46.0291 32.8505 45.5193 31.5172C43.0722 25.5172 39.0618 26.3505 37.3624 27.5172C34.9834 29.6839 28.8997 31.9172 23.5977 23.5172C18.7036 13.9172 14.7611 15.5172 13.4017 17.5172C12.552 18.3505 10.037 21.7172 6.77422 28.5172C3.51147 35.3172 5.75461 36.6838 7.28402 36.5172ZM41.2945 15C43.8285 15 45.8827 12.9853 45.8827 10.5C45.8827 8.01472 43.8285 6 41.2945 6C38.7605 6 36.7063 8.01472 36.7063 10.5C36.7063 12.9853 38.7605 15 41.2945 15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtract);
export default __webpack_public_path__ + "static/media/subtract.c6fe91c7469e507a63b02946e0678b1d.svg";
export { ForwardRef as ReactComponent };